// extracted by mini-css-extract-plugin
export var cancelButton = "_pd-5";
export var content = "_pd-3";
export var createButton = "_pd-6";
export var drawerContainer = "_pd-0";
export var footer = "_pd-2";
export var header = "_pd-1";
export var orderFormColumn = "_pd-4";